import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from 'App'; // ✅ Ruta absoluta

// --- MOTORES DE INTELIGENCIA Y SEGURIDAD ---
// Importamos usando las rutas directas para evitar errores de compilación
import { AuthProvider } from 'context/AuthContext';
import { GlobalProvider } from 'context/GlobalContext';

/**
 * ARQUITECTURA DE DATOS IGLEKIDS V3.0
 * 1. AuthProvider: El "Portero". Gestiona el login y el rol (Admin, Maestro, etc).
 * 2. GlobalProvider: El "Cerebro". Gestiona los datos de niños y alertas en tiempo real.
 * NOTA: El Cerebro vive dentro del Portero para garantizar que las consultas 
 * a Firebase se hagan con una sesión activa y segura.
 */

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <GlobalProvider>
        <App />
      </GlobalProvider>
    </AuthProvider>
  </React.StrictMode>
);